import { eq } from "drizzle-orm";
import { employee, type PowerSyncDrizzleDB } from "@comandero/powersync";
import { nowISO } from "../utils/date-helpers";
import { generateUUID } from "../utils/uuid";

export type EmployeeRole = "waiter" | "cashier" | "manager";

/**
 * Crea un empleado con PIN para login rápido en el POS compartido. El PIN es un
 * código corto de turno (no una credencial de cuenta); la autenticación real es
 * el usuario logueado. CC-7: escritura con await.
 */
export async function createEmployeeMutation(
  db: PowerSyncDrizzleDB,
  organizationId: string,
  name: string,
  opts?: { pin?: string; role?: EmployeeRole; branchId?: string | null },
): Promise<string> {
  const id = generateUUID();
  const now = nowISO();
  await db.insert(employee).values({
    id,
    organization_id: organizationId,
    branch_id: opts?.branchId ?? null,
    name: name.trim(),
    pin: opts?.pin?.trim() || null,
    role: opts?.role ?? "waiter",
    is_active: 1,
    created_at: now,
    updated_at: now,
  });
  return id;
}

export async function deleteEmployeeMutation(
  db: PowerSyncDrizzleDB,
  employeeId: string,
): Promise<void> {
  const now = nowISO();
  await db
    .update(employee)
    .set({ deleted_at: now, updated_at: now })
    .where(eq(employee.id, employeeId));
}

/** Verifica un PIN contra los empleados activos cargados; devuelve el id o null. */
export function findEmployeeByPin(
  employees: { id: string; pin: string | null }[],
  pin: string,
): string | null {
  const trimmed = pin.trim();
  if (!trimmed) {
    return null;
  }
  return employees.find((e) => e.pin === trimmed)?.id ?? null;
}
